import { Flex } from "@chakra-ui/react";
import { Modal } from "antd";
import FooterModal from "ui/components/Button/FooterModal";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";

interface ModalInicioSubtenantsViewProps {
  isOpen: boolean;
  onClose: () => any;
  onOpenFiltros: () => any;
  onVerTudo: () => any;
}

function ModalInicioSubtenantsView({
  isOpen,
  onClose,
  onOpenFiltros,
  onVerTudo,
}: ModalInicioSubtenantsViewProps) {
  return (
    <Modal
      visible={isOpen}
      onCancel={onClose}
      width="600px"
      centered
      title="O que você deseja fazer?"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onClose={onClose}
          showRegisterAnother={false}
          buttonCancelarText="Fechar"
        />
      }
    >
      <Flex gap={4} justifyContent="center">
        <OutlineButton onClick={onOpenFiltros}>Filtrar</OutlineButton>

        <PrimaryButton onClick={onVerTudo}>Ver tudo</PrimaryButton>
      </Flex>
    </Modal>
  );
}

export default ModalInicioSubtenantsView;
